module.exports = __webpack_public_path__ + "media/src/img/viedit_logo_black-dc8d8e4d01ccbfd5d674a5492a5ae39de4fdaa9818f484a02d6960a94db819ca.svg";